import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import PromoBanner from "./promo-banner";
import SoldOutBanner from "./sold-out-banner";

const { siteMetadata: config } = GatsbyConfig;

export default class Banners extends React.Component {
  render() {
    const { trip } = this.props;
    const tripData = config.trips[trip];

    return (
      <div>
        {tripData.soldOut && tripData.soldOutReferralTrip && (
          <SoldOutBanner trip={trip} to={tripData.soldOutReferralTrip} />
        )}
        {!tripData.soldOut &&
          tripData.banners.map((banner) => (
            <PromoBanner trip={trip} kind={banner} />
          ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/banners.js